/** Who an authorization pays; the adjuster picks it when authorizing. */
export enum PayeeType {
  CUSTOMER = 'CUSTOMER',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
}

/** e.g. "Joe's Auto (repair shop)"; null when there's no payee. */
export function describePayee(payee: { payeeType: PayeeType | null; payeeName: string | null }) {
  if (!payee.payeeType) return null;

  const kind = payee.payeeType === PayeeType.SERVICE_PROVIDER ? 'repair shop' : 'customer';
  return payee.payeeName ? `${payee.payeeName} (${kind})` : kind;
}
